import HttpRequest from './HttpRequest'

class ContactTypeProvider extends HttpRequest {
  findAll () {
    return this.get('/contact-type')
  }

  findOne (id) {
    return this.get(`/contact-type/${id}`)
  }

  create (payload) {
    return this.post('/contact-type', payload)
  }

  update (id, payload) {
    return this.patch(`/contact-type/${id}`, payload)
  }

  softDelete (id) {
    return this.delete(`/contact-type/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/contact-type?page=${page}&limit=${limit}`, query)
  }
}

export default ContactTypeProvider
